module.exports = __webpack_public_path__ + "img/seriale-solo.23072264.jpeg";